import React, { useRef } from "react";
import { useDraggable } from "react-use-draggable-scroll";
import classNames from "classnames";

import PropTypes from "prop-types";
import { v4 } from "uuid";
import styles from "./EventList.module.css";
import EventItem from "../EventItem";

/**
 * Interactive component.
 * Scrollable list of events with a header.
 */
export function EventList({ events, onClick }) {
  const ref = useRef();
  const { events: draggableEvents } = useDraggable(ref);

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <p className={styles.item}>Job Code</p>
        <p className={styles.item}>Event Name</p>
        <p className={styles.item}>Registered Group</p>
        <p className={styles.item}>Status</p>
      </div>
      <ul className={classNames(styles.dragger)} {...draggableEvents} ref={ref}>
        {events.map((event) => {
          const id = v4();
          return (
            <EventItem
              eventInfo={event}
              key={id + event.jobCode}
              onClick={() => onClick(event.id)}
              onGroupClick={
                event.jobCode === "456"
                  ? () => alert("onGroupClick clicked.")
                  : null
              }
            />
          );
        })}
      </ul>
    </div>
  );
}

EventList.propTypes = {
  /**
   * Array of event objects.
   */
  events: PropTypes.arrayOf(
    PropTypes.shape({
      jobCode: PropTypes.string,
      name: PropTypes.string,
      group: PropTypes.string,
      status: PropTypes.bool,
    })
  ),
};
